import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import { TranslationsProvider } from './TranslationsProvider'
import { RouterProvider } from 'react-router-dom'
import { router } from './AppRouter'
import { ThemeProvider } from './ThemeProvider'
import { GlobalStyles } from './GlobalStyles'
import { Suspense } from 'react'
import { Spinner } from '../components'
import { ToastContainer } from '../components/atoms/Toast'

export const Providers: React.FC = () => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TranslationsProvider>
          <ToastContainer>
            <Suspense fallback={<Spinner />}>
              <RouterProvider router={router} />
            </Suspense>
          </ToastContainer>
        </TranslationsProvider>
      </QueryClientProvider>
      <GlobalStyles />
    </ThemeProvider>
  )
}
